export default function ConfidenceScoreBadge({ score, reasons }) {
  const tier = score >= 80 ? 'high' : score >= 60 ? 'medium' : 'low'
  
  const colors = {
    high: 'bg-green-100 text-green-800',
    medium: 'bg-yellow-100 text-yellow-800',
    low: 'bg-red-100 text-red-800'
  }

  const stars = {
    high: '⭐⭐⭐',
    medium: '⭐⭐',
    low: '⭐'
  }

  const parsedReasons = typeof reasons === 'string' ? JSON.parse(reasons) : reasons

  return (
    <div className="flex flex-col gap-1">
      <div className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${colors[tier]}`}>
        <span className="mr-1">{stars[tier]}</span>
        {score}% {tier}
      </div>
      {parsedReasons && parsedReasons.length > 0 && (
        <div className="text-xs text-gray-500">
          {parsedReasons.slice(0, 2).map((reason, idx) => (
            <div key={idx}>• {reason}</div>
          ))}
        </div>
      )}
    </div>
  )
}

